import React, {useContext, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SideMenu from './SideMenu';
import Header from './Header';
import Map from './Map';
import {ViewContext} from './contexts/ViewContext';
import Dashboard from './Dashboard';

const useStyles = makeStyles((theme) => ({
	toolbar: theme.mixins.toolbar,
}));

export default function Main() {
	const {view} = useContext(ViewContext);

	const classes = useStyles();

	let renderedContent = <React.Fragment></React.Fragment>;

	switch (view.selectedView) {
		case 'Map':
			renderedContent = (
				<div>
					<SideMenu />
					<Map />
				</div>
			);
			break;
		case 'Dashboard':
			renderedContent = <Dashboard />;
			break;

		default:
			break;
	}

	return (
		<div>
			<Header />
			{renderedContent}
		</div>
	);
}
